import axios from "axios";
import config from '../config'

export function getUserStats(address) {
    let statsUrl = `${config.URL}/api/lands/stats/${address}/`;
    return axios.get(statsUrl).then((response) => {
            return response.data.data
    });
}